module.exports = __webpack_public_path__ + "static/media/circle-x.38688a81.svg";